function SectionCard({ title, status, statusColor, children }) {
    return (
        <div style={{ marginBottom: '25px', padding: '20px', border: '1px solid #ddd', borderRadius: '8px', backgroundColor: 'white' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                <h4 style={{ margin: 0 }}>{title}</h4>
                {status && (
                    <span style={{
                        padding: '2px 10px',
                        borderRadius: '10px',
                        fontSize: '11px',
                        fontWeight: 'bold',
                        backgroundColor: statusColor?.bg || '#e2e3e5',
                        color: statusColor?.text || '#41464b'
                    }}>
                        {status}
                    </span>
                )}
            </div>
            {children}
        </div>
    );
}

function AdminAeo({ tabName }) {
    return (
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '20px' }}>
            <h3>{tabName}</h3>
            <p style={{ color: '#666', fontSize: '14px', marginTop: '-10px', marginBottom: '25px' }}>
                AEO/GEO = getting OkGather recommended directly by AI answer engines (ChatGPT, Perplexity, etc.),
                not just ranked by traditional search. This tab covers technical AI-crawler visibility and Reddit
                specifically - see the sibling <strong>SEO / Blog</strong>, <strong>Personas</strong>, and
                <strong> Socials</strong> tabs under Growth for the rest of the content pipeline.
            </p>

            <SectionCard title="Theme landing page crawlability" status="Built" statusColor={{ bg: '#d4edda', text: '#155724' }}>
                <p style={{ fontSize: '14px', color: '#333', margin: 0 }}>
                    Theme/group landing pages (<code>/theme/&lt;slug&gt;</code>) are server-rendered with the real
                    hero/benefits/description copy and <code>Event</code>/<code>BreadcrumbList</code> structured data,
                    so non-JS crawlers (most AI answer engines) can actually read the page - previously they saw an
                    empty shell, which meant LLMs defaulted to citing Meetup.com instead of OkGather directly.
                </p>
            </SectionCard>

            <SectionCard title="Reddit" status="Evaluating - not built" statusColor={{ bg: '#fff3cd', text: '#856404' }}>
                <p style={{ fontSize: '14px', color: '#333', marginBottom: '12px' }}>
                    Reddit content is heavily weighted by AI answer engines for product-recommendation queries. Plan
                    is human-seeded input -&gt; AI-drafted reply/post -&gt; human review -&gt; posted from a real
                    OkGather-controlled account (not automated), to stay inside Reddit's terms and avoid ban risk.
                    No in-house tooling built yet - the options below cover the monitoring/drafting half; none of
                    them do proactive discovery of new subreddits to join, which stays a manual task either way.
                </p>

                <div style={{ borderTop: '1px solid #eee', paddingTop: '12px', marginBottom: '12px' }}>
                    <p style={{ fontSize: '14px', fontWeight: 'bold', margin: '0 0 4px 0' }}>
                        <a href="https://redreach.ai/" target="_blank" rel="noopener noreferrer">RedReach</a> /{' '}
                        <a href="https://replydaddy.com/" target="_blank" rel="noopener noreferrer">ReplyDaddy</a>
                        {' '}- monitor + draft only, manual posting
                    </p>
                    <p style={{ fontSize: '13px', color: '#666', margin: 0 }}>
                        Scan Reddit for relevant posts, score relevance, draft replies in your voice/persona. No
                        Reddit account linking, no auto-posting - you copy-paste and post from OkGather's own
                        account, same manual-posting plan as above. RedReach ~$19-29/mo; ReplyDaddy is one-time
                        lifetime pricing but you bring your own Anthropic/OpenAI API key.
                    </p>
                </div>

                <div style={{ borderTop: '1px solid #eee', paddingTop: '12px' }}>
                    <p style={{ fontSize: '14px', fontWeight: 'bold', margin: '0 0 4px 0' }}>
                        <a href="https://www.replyagent.ai/" target="_blank" rel="noopener noreferrer">ReplyAgent</a> /{' '}
                        <a href="https://replymer.com/" target="_blank" rel="noopener noreferrer">Replymer</a>
                        {' '}- full pipeline, but posts via their own aged/rented accounts
                    </p>
                    <p style={{ fontSize: '13px', color: '#666', margin: 0 }}>
                        Cover discovery through posting end to end, faster since their accounts already have karma/
                        history instead of starting cold. Trade-off: it's not OkGather's own account, a ban wave
                        against their account fleet takes our posts down with it, and subreddits are increasingly
                        good at spotting managed marketing accounts (mod removal/backlash risk). ReplyAgent ~$79/mo
                        + pay-per-surviving-post; Replymer ~$99-399/mo by reply volume.
                    </p>
                </div>

                <div style={{ borderTop: '1px solid #eee', paddingTop: '12px', marginTop: '12px' }}>
                    <p style={{ fontSize: '13px', color: '#666', margin: 0, fontStyle: 'italic' }}>
                        Once there's a real body of Reddit activity (posts/comments made, subreddits joined), worth
                        asking Claude to build the same kind of gap-analysis tool as the SEO/Blog tab's "Content
                        Coverage Review" - which subreddits/topics we've actually covered vs. gone quiet on, and
                        what to post/reply to next. Not worth building against zero content now.
                    </p>
                </div>
            </SectionCard>

            <SectionCard title="AI-visibility tracking tools" status="Evaluated - not adopted" statusColor={{ bg: '#e2e3e5', text: '#41464b' }}>
                <p style={{ fontSize: '14px', color: '#333', margin: 0 }}>
                    Platforms like <a href="https://otterly.ai/" target="_blank" rel="noopener noreferrer">Otterly.AI</a>,{' '}
                    <a href="https://scrunch.com/" target="_blank" rel="noopener noreferrer">Scrunch AI</a> (general AI-answer
                    citation tracking), and <a href="https://reddgrow.ai/" target="_blank" rel="noopener noreferrer">ReddGrow</a>
                    {' '}(Reddit-specific - careful, don't confuse with the unrelated competing product redditgrow.ai) track
                    whether/how often a brand gets cited in AI answer engines. Deliberately not adopted yet - with
                    near-zero current OkGather visibility in LLM answers, this is a measurement layer, not a growth
                    lever: better to put effort into content that creates citations (this page's other sections)
                    first, and revisit monitoring once there's a baseline worth tracking.
                </p>
            </SectionCard>

            <SectionCard title="PR" status="Not started" statusColor={{ bg: '#e2e3e5', text: '#41464b' }}>
                <p style={{ fontSize: '14px', color: '#333', margin: 0 }}>
                    Phase 2, after Reddit + blog prove out the human-in-the-loop pattern. Likely buy/hire, not build -
                    journalist/podcast/newsletter outreach tools like{' '}
                    <a href="https://magicpitch.com/" target="_blank" rel="noopener noreferrer">Magic Pitch</a> or{' '}
                    <a href="https://presspitchai.com/" target="_blank" rel="noopener noreferrer">PressPitch AI</a>,
                    or a freelance PR person - this is relationship-driven outreach, not really an AI-draft/approve/
                    submit pipeline the way the other channels on this page are.
                </p>
            </SectionCard>
        </div>
    );
}

export default AdminAeo;
